import dice from './dice'
import diceShot from './diceShot'
export default {
  components:{
    dice,
    diceShot,
    diceBattle: dice,
    none: dice
  },
}
